// /* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react'
import {
  FlexboxGrid, DatePicker, Timeline, Checkbox, CheckboxGroup, Form, FormControl,
  Divider, Icon, IconButton, ButtonToolbar, FormGroup, SelectPicker, Drawer, Modal, Button
} from 'rsuite'
import { addEvent } from '../Context/firebase'
// import { getActivities } from '../Context/prismic'
import { getActivity } from '../Context/prismic'
import { useAuth } from '../Context/Auth'
import { Prompt, useLocation, useHistory } from 'react-router-dom'

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import ActivityPickerModal from '../Components/ActivityPickerModal'
import ActivityPreview from '../Components/ActivityPreview'
import '../Components/Styles/event.css'
import { colors, fonts } from '../Components/Styles/common-styles'
import dateFns from 'date-fns'
import {
  H1, Title, FlexWrapper, InlineFlex, Back, SmallTitle, StartButton, NormalText
} from '../Components/MyEvent/MyEventStyledComponents'
import { EmptyTimeline, SummaryBlock, AddEventActivity, ActivityCard, DeleteModal, EmptyPhaseModal, PhaseSummary } from '../Components/MyEvent/EventComponents'
import { Bin, FlagWarning } from '../Components/Icons'
import styled from 'styled-components'

import _ from 'lodash'
import { v4 } from 'uuid'

const MyDrawer = styled(Drawer)`
-webkit-animation: slide-in 0.7s forwards;
.rs-drawer-content {
  overflow: auto;
},
`

const Styles = {
  toolBar: {
    display: 'inline-flex',
    lineHeight: 1.42857143,
    marginRight: '1%'
  }
}

const goalsMockup = [
  {
    title: 'conduct good teamwork and...',
    goals: ['work actively together',
      'build a confidential working atmosphere',
      'come up with something new together',
      'involve all participants in the work as equally as possible',
      'make hidden knowledge in the work community visible for shared use at the team and organisational level',
      'share knowledge and each other',
      'review what have we achieved by the end'
    ]
  },
  {
    title: 'develop a clear plan and...',
    goals: [
      'agree on how to monitor progress',
      'clarify the goals of the event as well as the common ways in which they will be achieved',
      'prioritize and selecting the ideas to be developed'
    ]
  },
  {
    title: 'learn the subject and...',
    goals: ['receive new information and learn about new subject',
      'look at the theme from new perspectives and challenge our thinking',
      'refine the subject forward',
      'share thoughts with each other',
      'practice'
    ]
  },
  {
    title: 'evaluate success and...',
    goals: ['agree how we will proceed in the future',
      'decide how to gather feedback and evaluate success']
  }
]

const CreateEventPage = () => {
  const { currentUser } = useAuth()
  const [isSaved, setSaved] = useState(false)
  const [isActivityPickerVisible, setActivityPickerVisible] = useState(false)
  const [showModal, setModalShown] = useState(false)
  const [updated, setUpdated] = useState(false)
  const [showPhaseModal, setPhaseModal] = useState(false)
  // this state shows activity preview after clicking on added activity card
  const [showActivityPreviewModal, setActivityPreviewModal] = useState(false)
  const [activityId, setActivityId] = useState(null)
  const [selectedPhaseIndex, setSelectedPhaseIndex] = useState(0)
  const [goalsArray, setGoals] = useState([])
  const [timeArray, setTimeArray] = useState([])
  const [addNewPhase, setNewPhase] = useState(false)
  const [error, setError] = useState('')
  const [event, setEvent] = useState({
    id: v4(),
    title: '',
    date: null,
    phases: [],
    author: currentUser.uid
  })
  const [showEditModal, setEditModal] = useState(false)
  const [shouldBlockNavigation, setShouldBlockNavigation] = useState(false)
  const location = useLocation()
  const history = useHistory()
  const [lastLocation, setLastLocation] = useState(location)

  const template = {
    goals: [],
    phases: [
      { name: 'Warm up', data: [] },
      { name: 'Work', data: [] },
      { name: 'Wrap up', data: [] }
    ]
  }

  useEffect(() => {
    if (goalsArray.length && !event.phases) {
      setEvent({ ...event })
      setNewPhase(true)
    } else if (!goalsArray.length) {
      setEvent({ ...event })
      setNewPhase(false)
    }
  }, [goalsArray.length])

  useEffect(() => {
    let i; let j
    for (i = 0; i < 24; i++) {
      for (j = 0; j < 4; j++) {
        timeArray.push({
          label: (i < 10 ? '0' + i : i) + ':' + (j === 0 ? '00' : 15 * j),
          value: (i < 10 ? '0' + i : i) + ':' + (j === 0 ? '00' : 15 * j)
        })
      }
    }
    setTimeArray([...timeArray])
  }, [])

  useEffect(() => {
    if (event) {
      setEvent({ ...event })
    }
    return setUpdated(false)
  }, [updated])

  useEffect(() => {
    if (shouldBlockNavigation && !showEditModal) {
      console.log('here', lastLocation.pathname)
      history.push(lastLocation.pathname)
      setShouldBlockNavigation(false)
    }
  }, [shouldBlockNavigation])

  const handleBlockedRoute = (nextlocation) => {
    if (!shouldBlockNavigation) {
      setEditModal(true)
      setLastLocation(nextlocation)
      return false
    }
    return true
  }

  // input field handler
  const handleChange = (name, data) => {
    event[name] = data
    setEvent({ ...event })
    setSaved(false)
  }
  // date change handler
  const handleDateChange = (name, date) => {
    const newDate = new Date(event.date)
    if (date !== null) {
      if (name !== 'time') {
        newDate.setDate(date.getDate())
        newDate.setMonth(date.getMonth())
        newDate.setYear(date.getYear() + 1900) // why? https://developer.mozilla.org/ru/docs/Web/JavaScript/Reference/Global_Objects/Date/getYear
        setEvent({ ...event, date: +newDate })
      } else {
        newDate.setHours(date.split(':')[0])
        newDate.setMinutes(date.split(':')[1])
        setEvent({ ...event, date: +newDate })
      }
    }
    setSaved(false)
  }

  // updating phase handler
  const handlePhaseChange = (index, e) => {
    event.phases[index].name = e
    setEvent({ ...event })
    setSaved(false)
    setError('')
  }

  // New phase handler
  const addPhase = () => {
    event.phases.push({ name: '', data: [] })
    setEvent({ ...event })
    setNewPhase(false)
    setPhaseModal(false)
  }
  // activity card selection handler
  async function onSelectActivity (id) {
    const activity = await getActivity(id)
    if (activity) {
      activity.id = v4()
      event.phases[selectedPhaseIndex].data.push({ ...activity })
      setEvent({ ...event })
      setUpdated(true)
      setSaved(false)
    }
  }

  // Function to delete a single activity
  const handleActivityDelete = (props) => {
    const id = props.currentTarget.value
    const index = props.currentTarget.getAttribute('index')
    event.phases[index].data.splice(_.indexOf(event.phases[index].data, id), 1)
    setEvent({ ...event })
    props.stopPropagation()
  }

  // Function to delete a phase
  const handlePhaseDelete = (props) => {
    event.phases.splice(selectedPhaseIndex, 1)
    setEvent({ ...event })
    if (!event.phases.length) {
      setPhaseModal(true)
    }
    setModalShown(false)
  }

  // const handlePhaseDrag = (result) => {
  //   const items = Array.from(event.phases)
  //   const [reorderedItem] = items.splice(result.source.index, 1)
  //   items.splice(result.destination.index, 0, reorderedItem)
  //   event.phases = items
  //   setEvent({ ...event })
  // }

  const handleActivityDrag = (result) => {
    if (!result.destination) return
    if (result.source.droppableId !== result.destination.droppableId) {
      const sourcePhase = Array.from(event.phases[result.source.droppableId].data)
      const [removed] = sourcePhase.splice(result.source.index, 1)
      event.phases[result.source.droppableId].data = Array.from(sourcePhase)

      const destinationPhase = Array.from(event.phases[result.destination.droppableId].data)
      destinationPhase.splice(result.destination.index, 0, removed)
      event.phases[result.destination.droppableId].data = [...destinationPhase]

      setEvent({ ...event })
      return
    }
    const items = Array.from(event.phases[result.source.droppableId].data)
    const [reorderedItem] = items.splice(result.source.index, 1)
    items.splice(result.destination.index, 0, reorderedItem)
    event.phases[result.source.droppableId].data = [...items]
    setEvent({ ...event })
  }
  // Save to firestore
  async function handleSave () {
    try {
      console.log('try to save', event)
      await addEvent(event.id, {
        ...event,
        goalsArray
      })
    } catch (error) {
      console.error(error)
      setSaved(false)
      return setError('Unable to save event. Please make sure you have filled all fields')
    }
    setSaved(true)
    setError('')
  }

  const handleGoalSelect = (title, goal, selected, index) => {
    if (selected) {
      goalsArray.push({ title: title, goals: goal })
      if (goalsArray.length === 1) {
        template.phases.map(phase => event.phases.push(phase))
      }
    } else {
      _.remove(goalsArray, g => g.goals === goal)
      if (!goalsArray.length) {
        event.phases = []
      }
    }
    setGoals([...goalsArray]) // for force rerendering
    setSaved(false)
  }
  const getGoals = () => goalsArray ? goalsArray.map(i => i.goals) : event.goals
  const editActivity = (id, phase) => {
    console.log(phase)
    if (id) {
      const index = event.phases[phase].data.findIndex(activity => activity.id === id)
      const data = event.phases[phase].data[index]
      setSaved(false)
      return { data, index }
    }
  }

  return (
    <FlexboxGrid justify='center' style={{ margin: '26px 20px 20px 28px' }}>
      <Prompt when message={handleBlockedRoute} />

      <ActivityPickerModal
        isActivityPickerVisible={isActivityPickerVisible}
        setActivityPickerVisible={setActivityPickerVisible}
        onSelectActivity={onSelectActivity}
        goals={getGoals()}
      />
      <MyDrawer
        full
        show={showActivityPreviewModal}
        onHide={() => setActivityPreviewModal(false)}
      >
        <ActivityPreview
          setActivityPreviewModal={setActivityPreviewModal}
          // activityId={showActivityPreviewModal}
          event={event}
          setEvent={setEvent}
          phaseIndex={selectedPhaseIndex}
          data={() => editActivity(activityId, selectedPhaseIndex)}
        />
      </MyDrawer>

      <EditModal
        show={showEditModal}
        handleClose={() => setEditModal(false)}
        continueEdit={() => { setEditModal(false) }}
        onDelete={() => { setShouldBlockNavigation(true); setEditModal(false) }}
      />

      <DeleteModal
        show={showModal}
        handleClose={() => setModalShown(false)}
        setSelectedPhaseIndex={setSelectedPhaseIndex}
        onDelete={(selectedPhaseIndex) => handlePhaseDelete}
        title={!event.phases.length ? null : event?.phases[selectedPhaseIndex]?.name || 'unnamed phase'}
        msg='Phase'
      />
      <EmptyPhaseModal
        show={showPhaseModal}
        handleClose={() => setModalShown(false)}
        addPhase={addPhase}
        onDelete={e => { window.location.href = '/events' }}
      />
      <Form style={{ width: '100%' }}>
        <FlexboxGrid.Item colspan={24}>
          {error && <div style={{ color: `${colors.errorRed}` }}>{error}</div>}
          <H1 style={{ margin: '1%' }}>Create new event</H1>
          <InlineFlex style={{ width: '100%', height: '100%' }}>
            <FormGroup colSpan={20} style={{ margin: '0 1%' }}>
              <FormControl
                placeholder='Name your event'
                name='name'
                onChange={title => handleChange('title', title)}
                style={{ width: '400px', height: '40px', fontSize: `${fonts.largeSize}` }}
              />
            </FormGroup>
            <FormGroup>
              <ButtonToolbar style={Styles.toolBar} colSpan={4}>
                <Button
                  style={{ borderColor: `${colors.purpleMain}`, color: `${colors.purpleMain}` }}
                  appearance='ghost'
                  onClick={e => { window.location.href = '/events' }}>Cancel</Button>
                {!isSaved
                  ? <StartButton
                    appearance='primary'
                    onClick={() => handleSave()}>
                    Save
                  </StartButton>
                  : <Button
                    style={{ backgroundColor: colors.pink }}
                    appearance='primary'>
                    Saved !</Button>}
              </ButtonToolbar>
            </FormGroup>
          </InlineFlex>
        </FlexboxGrid.Item>
        <InlineFlex style={{ width: '100%' }}>
          <FlexboxGrid.Item colspan={8} className='scroll'>
            <InlineFlex>
              <FlexWrapper>
                <p>Date *</p>
                <DatePicker
                  oneTap
                  onChange={(date) => handleDateChange('date', date)}
                  style={{ width: '200px' }}
                  placeholder='Select Date'
                  disabledDate={date => dateFns.isBefore(date, new Date())}
                  isoWeek />
              </FlexWrapper>
              <FlexWrapper style={{ marginLeft: '10%' }}>
                <p>Starts at *</p>
                <SelectPicker
                  data={timeArray}
                  placeholder='Select Time'
                  onChange={(date) => handleDateChange('time', date)}
                  searchable={false}
                  style={{ width: 150, textAlign: 'center' }}
                  className='rs-picker-date-only-time'
                />
              </FlexWrapper>
            </InlineFlex>
            <SummaryBlock data={event} style={{ width: '100%', display: 'flex', flexflow: 'wrap', justifyContent: 'space-between' }} />
            <Divider />
            <FlexWrapper>
              <H1>Goals</H1>
              <Title>I want to....</Title>
              {
                goalsMockup.map((block, index) =>
                  <GoalsBlock
                    handleGoalSelect={handleGoalSelect}
                    key={index}
                    goals={block.goals}
                    title={block.title}
                  />)
              }
            </FlexWrapper>
          </FlexboxGrid.Item>
          <FlexboxGrid.Item colspan={16}>
            <DragDropContext onDragEnd={handleActivityDrag}>
              <Timeline className='customTimeline' endless>
                <FlexWrapper>
                  {!goalsArray.length
                    ? <EmptyTimeline />
                    : null}
                  {goalsArray.length && event.phases.length
                    ? <PhasesConstructor
                      phases={event.phases}
                      onClickAdd={() => setActivityPickerVisible(true)}
                      setSelectedPhaseIndex={setSelectedPhaseIndex}
                      handleChange={handlePhaseChange}
                      handleDelete={handleActivityDelete}
                      showDeleteModal={setModalShown}
                      setActivityId={setActivityId}
                      setActivityPreviewModal={setActivityPreviewModal}
                    />
                    : null}
                  {addNewPhase &&
                    <NewPhase
                      addPhase={addPhase()}
                      onClickAdd={() => setActivityPickerVisible(true)}
                      setSelectedPhaseIndex={setSelectedPhaseIndex}
                      handleChange={handlePhaseChange}
                      phases={event}
                    />}
                  {goalsArray.length
                    ? <Timeline.Item dot={<Icon className='customDot' icon='' />}>
                      <Back onClick={() => setNewPhase(true)} colored padded> &#x2B; create new phase</Back>
                    </Timeline.Item>
                    : null}
                </FlexWrapper>
              </Timeline>
            </DragDropContext>
          </FlexboxGrid.Item>
        </InlineFlex>
      </Form>
    </FlexboxGrid>
  )
}

const GoalsBlock = ({ title, goals, handleGoalSelect }) =>
  <>
    <Title>{title}</Title>
    <CheckboxGroup>
      {goals.map((goal, index) =>
        <Checkbox
          onChange={(value, checked) => handleGoalSelect(title, goal, checked, index)}
          key={index}>
          {goal}
        </Checkbox>)}
    </CheckboxGroup>
  </>

const PhasesConstructor = ({
  phases, onClickAdd, setActivityPreviewModal, setActivityId,
  setSelectedPhaseIndex, handleChange, handleDelete, showDeleteModal
}) => {
  return (
    <>
      {phases.map((phase, index) =>
        <Timeline.Item
          dot={<Icon className='customDot' icon='' />}>
          <InlineFlex
            style={{ width: '80%' }}>
            <div style={{ display: 'inline-flex' }}>
              <SmallTitle style={{ width: '100px', padding: '7px 11px', margin: '0', alignSelf: 'flex-start' }} bolded>Phase {index + 1}: </SmallTitle>
              <FormControl
                style={{ border: 'none', background: 'transparent', fontSize: `${fonts.bigSize}`, alignSelf: 'flex-start' }}
                defaultValue={phase.name}
                value={phase.name}
                onChange={(e) => handleChange(index, e)}
                name='phase name' />
            </div>
            <div style={{ display: 'inline-flex' }}>
              <PhaseSummary {...phase} />
              <IconButton
                style={{ alignSelf: 'flex-end' }}
                className='i-button'
                onClick={() => {
                  setSelectedPhaseIndex(index)
                  showDeleteModal()
                }}
                icon={<Bin stroke={colors.grey} />} />
            </div>
          </InlineFlex>
          <Droppable droppableId={index.toString()} key={index} direction='horizontal'>
            {(provided, snapshot) => (
              <div
                {...provided.droppableProps}
                ref={provided.innerRef}
                isDraggingOver={snapshot.isDraggingOver}
                style={Styles.dragging}>
                <FlexWrapper>
                  <InlineFlex style={{ justifyContent: 'flex-start', flexWrap: 'wrap' }}>
                    {phase.data.map((item, i) => {
                      return (
                        <Draggable key={item.id} draggableId={item.id} index={i}>
                          {(provided) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}>
                              <ActivityCard
                                previewOnClick={setActivityPreviewModal}
                                setActivityId={setActivityId}
                                setSelectedPhaseIndex={setSelectedPhaseIndex}
                                key={i}
                                data={item}
                                handleDelete={handleDelete}
                                index={index}
                                activityindex={i}
                              />
                            </div>
                          )}
                        </Draggable>
                      )
                    })}
                    <AddEventActivity
                      onClick={() => {
                        setSelectedPhaseIndex(index)
                        onClickAdd()
                      }}
                      phases={phases}
                    />
                    {provided.placeholder}
                  </InlineFlex>
                </FlexWrapper>
              </div>
            )}
          </Droppable>
        </Timeline.Item>

      )}
    </>
  )
}

const NewPhase = ({ onClickAdd, setSelectedPhaseIndex, handleChange, phases }) => {
  const i = phases.phases.length - 1
  return (
    <>
      <Timeline.Item dot={<Icon className='customDot' icon='' />}>
        <PhaseForm
          index={i}
          phases={phases}
          handleChange={handleChange} />
        <AddEventActivity
          onClick={() => {
            setSelectedPhaseIndex(i)
            onClickAdd()
          }}
          phases={phases}
        />
      </Timeline.Item>
    </>
  )
}
const PhaseForm = ({ index, handleChange, phases }) => {
  return (
    <InlineFlex style={{ justifyContent: 'flex-start', width: '100%' }}>
      <SmallTitle style={{ width: '100px' }} bolded>Phase {index + 1}: </SmallTitle>
      <FormControl
        style={{ border: 'none', background: 'transparent', fontSize: `${fonts.largePlusSize}`, color: `${colors.black}` }}
        placeholder='Enter Phase Name'
        onChange={(e) => handleChange(e, index)}
      />
    </InlineFlex>
  )
}

const EditModal = ({ show, handleClose, continueEdit, onDelete }) => {
  return (
    <Modal
      className='deleteModal'
      show={show}
      onHide={handleClose}
      style={{ width: '480px', height: 'auto', margin: 'auto' }}
    >
      <Modal.Header>
        <IconButton style={{ display: 'flex', justifyContent: 'center', width: '100%', margin: 'auto', height: '100%', background: 'transparent' }} icon={<FlagWarning stroke={colors.purpleMain} />} size='lg' />
      </Modal.Header>
      <Modal.Body>
        <SmallTitle style={{ justifyContent: 'center' }} centered>Your event has some unsaved changes.</SmallTitle>
        <SmallTitle style={{ justifyContent: 'center' }} centered>Sure you want to leave?</SmallTitle>
        <NormalText centered greyed>Make sure to save content before you go!</NormalText>
      </Modal.Body>
      <Modal.Footer>
        <ButtonToolbar style={{ textAlign: 'center', padding: '5%' }}>
          <Button
            onClick={continueEdit}
            style={{ borderColor: colors.grey, color: colors.grey }}
            className='btn-grey'
            appearance='ghost'>
            Stay
          </Button>
          <Button
            onClick={onDelete}
            color='red'
            className='btn-red'
            appearance='ghost'>
            Leave
          </Button>
        </ButtonToolbar>
      </Modal.Footer>
    </Modal>
  )
}

export default CreateEventPage
